import React from 'react';

import Typography from '../../../../../../_ui/_blocks/Typography/Typography';
import Tag from '../../../../../../_ui/_blocks/Tag/Tag';

import styles from './FilterSection.module.css';

export enum FilterHeadings {
    brand = 'Brand',
    conditions = 'Condition',
    price = 'Price',
    treatmentForm = 'Treatment Form',
    drugClass = 'Drug Class',
    activeIngredient = 'Active Ingredient',
    productType = 'Product Type',
    review = 'Review',
    filter = 'Filter',
}

interface Props {
    title: string;
    children: React.ReactNode;
    numberSelected?: number;
    className?: string;
}

const FilterSection = ({ title, children, numberSelected = 0, className }: Props) => (
    <section className={className}>
        <Typography as="h4" typeset="subheading" className={styles.header} size='100'>
            {title}
            {numberSelected ? (
                <Tag color="info" size="large">
                    {numberSelected} selected
                </Tag>
            ) : null}
        </Typography>
        {children}
    </section>
);

export default FilterSection;
